module.exports = __webpack_public_path__ + "static/media/bg-fat-button.258a40f4.png";